import { IListaDocumentoTecnicoRegistrarModel } from "../../interfaces/solicitud/documento-tecnico/IListaDocumentoTecnicoRegistrarModel";
import { ISolicitudDocumentoTecnicoModel } from "../../interfaces/solicitud/documento-tecnico/ISolicitudDocumentoTecnicoModel";
import { SolicitudDocumentoTecnicoModel } from "../SolicitudDocumentoTecnicoModel";

export class ListaDocumentoTecnicoRegistrarModel implements IListaDocumentoTecnicoRegistrarModel {
    documentos: ISolicitudDocumentoTecnicoModel[];
    idSolicitud: number;
    comentarios: string;

    constructor(){
        this.documentos = new Array<SolicitudDocumentoTecnicoModel>();
        this.idSolicitud = 0;
        this.comentarios = '';
    }
}